module.exports = __webpack_public_path__ + "img/loading_cover.638db471.jpg";